<div class="btn-group" style="min-width: 150px;">
  <button type="button" style="min-width: 70px; min-height: 38px;" class="btn btn-outline-secondary" [disabled]="disable"
    [class.active]="value === true" (click)="changeValue(true)" name="customChoiceTrue">
    <i *ngIf="value === true" class="fa fa-check"></i><span>{{ choiceTrue || 'Yes' }}</span>
  </button>
  <button type="button" style="min-width: 70px; min-height: 38px;" class="btn btn-outline-secondary" [disabled]="disable"
    [class.active]="value === false" (click)="changeValue(false)" name="customChoiceFalse">
    <i *ngIf="value === false" class="fa fa-check"></i><span>{{ choiceFalse || 'No' }}</span>
  </button>
</div>